<template>
  <div class="retinueMorePage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
      @input="onSearch"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-moreContent" id="list-moreContent">
      <van-list
        v-model="Moreloading"
        :finished="Morefinished"
        finished-text="没有更多了"
      >
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in retinueMainList"
              clickable
              :key="item.id"
              :title="`${item.realName}`"
              @click="toggle(index, item)"
              class="item"
            >
              <van-checkbox
                :name="item.realName"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "retinueView",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      retinueMainList: [],
      retinueList: [], //项目人员列表
      result: [], //选择的项目人员列表
      retinuedata: [], //选中的项目人员列表
      transmitList: [],
      morePage: 1,
      morePageSize: 500,
      Moreloading: false, //是否处于加载状态
      Morefinished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    retinueUids: {
      type: Array,
      default: () => [],
    },
    retinueType: {
      type: Number,
    },
    changeUidsType: {
      type: String,
    },
  },
  mounted() {
    this.getMoreTest();
  },
  methods: {
    toggle(index, item) {
      this.$refs.checkboxes[index].toggle();
      this.retinuedata.push(item);
      this.unique(this.retinuedata);
    },
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;

      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getMoreTest() {
      let _this = this;

      _this.$api.baseCommon.baseMsg.dictBox
        .staffPageList(_this.morePage, _this.morePageSize, {
          realName: _this.searchName,
          enable: true,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.retinueMainList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.Moreloading = false;
            _this.Morefinished = true;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.Morefinished = true;
          console.log(err);
        });
    },
    viewLists() {
      let newArr = [];
      let arrType = window.sessionStorage.getItem("peopleMoreType");
      this.result = [];
      this.retinuedata = [];

      if (arrType && arrType == "firstContactName") {
        newArr = this.retinueUids;
        console.log(this.retinueUids,"retinueUids")
        if (newArr[0]) {
          for (let i = 0; i < newArr.length; i++) {
            for (let j = 0; j < this.retinueMainList.length; j++) {
              if (newArr[i] == this.retinueMainList[j].id) {
                this.result.push(this.retinueMainList[j].realName);
                this.retinuedata.push(this.retinueMainList[j]);
              }
            }
          }
        }
      } else {
        newArr = JSON.parse(window.sessionStorage.getItem("moreRetinueList"));
        if (newArr[0]) {
          for (let i = 0; i < newArr.length; i++) {
            for (let j = 0; j < this.retinueMainList.length; j++) {
              if (newArr[i].id == this.retinueMainList[j].id) {
                this.result.push(this.retinueMainList[j].realName);
                this.retinuedata.push(this.retinueMainList[j]);
              }
            }
          }
        }
      }
    },
    closeRetinuePicker() {
      this.$emit("moreSetReview", []);
    },
    saveRetinue() {
      let _this = this;
      let arrType = window.sessionStorage.getItem("peopleMoreType");
      this.getNewArr(this.retinuedata);
      if (arrType && arrType == "firstContactName") {
        _this.$emit("moreSetReview", _this.retinuedata);
      } else {
        window.sessionStorage.setItem(
          "moreRetinueList",
          JSON.stringify(this.retinuedata)
        );
        _this.$emit("moreSetReview", _this.transmitList);
      }
    },
    getNewArr(dataArray) {
      //数组去重
      let newArr = [];
      for (var i = 0; i < dataArray.length; i++) {
        var flag = true;
        for (var j = 0; j < newArr.length; j++) {
          if (dataArray[i].id == newArr[j].id) {
            flag = false;
            break;
          }
        }
        if (flag) {
          newArr.push(dataArray[i]);
        }
      }

      this.retinuedata = newArr;
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });

      _this.retinuedata = _this.retinuedata.filter(function () {
        return true;
      });
    },
    reloadPage() {
      this.retinueMainList = [];

      this.Moreloading = false; //是否处于加载状态
      this.Morefinished = false; //是否已加载完所有数据

      this.getMoreTest();
    },
  },
  watch: {
    retinueUids: {
      handler: function (valArray) {
        this.reloadPage();
      },
      deep: true,
    },
    changeUidsType: function (type) {
      this.reloadPage();
    },
  },
};
</script>
<style lang="less" >
.retinueMorePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-moreContent {
    height: calc(100% - 95px);
    overflow-y: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>